import {
  SET_INIT_CVW,
  SET_ERROR,
  INIT_CVW_CONTENT,
  SET_STEPPER_STATUS,
  SET_CURRENT_STEP,
  SET_USER_CVS_NUMBER,
  SET_USER_REGISTER_SMART_ALERTS,
} from "./mutation-types";

const mutations = {
  [INIT_CVW_CONTENT](state, data) {
    state.content = data;
  },

  [SET_STEPPER_STATUS](state, data) {
    state.stepperStatus = data;
  },

  [SET_USER_CVS_NUMBER](state, cvs) {
    state.userStatus.cvFiles = cvs;
  },
  [SET_USER_REGISTER_SMART_ALERTS](state, data) {
    state.userStatus.isRegisteredSmartAlerts = data;
  },

  [SET_CURRENT_STEP](state, stepNumber) {
    state.currentStep = stepNumber;
  },

  [SET_INIT_CVW](state) {
    state.initializedCVW = true;
  },

  [SET_ERROR](state, error) {
    state.errors.push(error);
  },
};

export default mutations;
